import { graphQLRequest } from "@/libs/graphql/graphQLRequest";
import { PromotionalOfferType } from "@leplein/graphql-public/clients/graphql-qrcode-client/graphql";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { GetChargingPoolQuery } from "../api/getChargingPool.graphql";
import { CHARGING_POOL_QUERY_KEYS } from "./keys";

const FIRST_FREE_CHARGE_OFFER_TYPES = new Set<PromotionalOfferType>([
	PromotionalOfferType.FirstFreeCharge_2026,
	PromotionalOfferType.FirstFreeChargeV2,
]);

export const chargingPoolQueryOptions = (evseId: string) =>
	queryOptions({
		queryKey: [CHARGING_POOL_QUERY_KEYS.GET_CHARGING_POOL, evseId],
		queryFn: () => graphQLRequest(GetChargingPoolQuery, { input: { evseId } }),
	});

export const useChargingPoolSuspenseQuery = (evseId: string) =>
	useSuspenseQuery({
		...chargingPoolQueryOptions(evseId),
		select: (data) => {
			const pool = data?.chargingPool;
			const retailerName = pool?.store?.retailer.name;
			const storeName = pool?.store?.name;
			const hasFirstFreeCharge = Boolean(
				pool?.promotionalOffers?.some((offer) => FIRST_FREE_CHARGE_OFFER_TYPES.has(offer.type)),
			);

			return { retailerName, storeName, hasFirstFreeCharge };
		},
	});
